import React from 'react';
import { scrollToSection } from './Navbar';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div className="site-footer__col">
          <p className="site-footer__brand">Select Data Labs</p>
          <p>Canadian data consulting for teams that want their data to actually work for them.</p>
        </div>

        <div className="site-footer__col">
          <h4>Services</h4>
          <button
            type="button"
            className="nav-link"
            onClick={() => scrollToSection('businessAnalytics')}
            style={{ padding: 0, color: 'inherit', display: 'block', textAlign: 'left' }}
          >
            Business &amp; Analytics
          </button>
          <button
            type="button"
            className="nav-link"
            onClick={() => scrollToSection('dataEngineering')}
            style={{ padding: 0, color: 'inherit', display: 'block', textAlign: 'left' }}
          >
            Data Engineering
          </button>
          <button
            type="button"
            className="nav-link"
            onClick={() => scrollToSection('cloudInfrastructure')}
            style={{ padding: 0, color: 'inherit', display: 'block', textAlign: 'left' }}
          >
            Cloud Enablement
          </button>
        </div>

        <div className="site-footer__col">
          <h4>Company</h4>
          <button
            type="button"
            className="nav-link"
            onClick={() => scrollToSection('howWeWork')}
            style={{ padding: 0, color: 'inherit', display: 'block', textAlign: 'left' }}
          >
            How we work
          </button>
          <button
            type="button"
            className="nav-link"
            onClick={() => scrollToSection('clients')}
            style={{ padding: 0, color: 'inherit', display: 'block', textAlign: 'left' }}
          >
            Clients
          </button>
        </div>

        <div className="site-footer__col">
          <h4>Get in touch</h4>
          <button
            type="button"
            className="nav-link modal-trigger"
            data-target="contactModal"
            style={{ padding: 0, color: 'inherit', display: 'block', textAlign: 'left' }}
          >
            Contact us
          </button>
          {/* TODO: replace with real LinkedIn URL once available */}
          {/* <a href="https://www.linkedin.com/company/select-data-labs" target="_blank" rel="noreferrer">LinkedIn</a> */}
          {/* TODO: make privacy page */}
          {/* <a href="/privacy">Privacy Policy</a> */}
          {/* TODO: make terms of service page */}
          {/* <a href="/terms">Terms of Service</a> */}
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>&copy; 2025 &ndash; {year} Select Data Labs, Inc. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
